import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip, Popover } from 'antd';
import { TagsOutlined } from '@ant-design/icons';
import IconButton from 'components/IconButton';
import { txt } from 'libs/i18n';
import { useSwitch } from 'hooks/useSwitch';
import TagsBulkEditDialog from '../../TagsBulkEditDialog/index';
import toolbarStyles from '../style.module.less';
const TagsEditButton = ({ selectionEmpty, selectedProjects, onRefetch, onComplete, }) => {
    const [openDialog, onOpenDialog, onCloseDialog] = useSwitch();
    return (selectionEmpty ? (_jsx(Tooltip, { title: txt('bulkTags'), children: _jsx("div", { children: _jsx(IconButton, { className: toolbarStyles.toolbarButton, id: "tagsPP", disabled: true, children: _jsx(TagsOutlined, {}) }) }) })) : (_jsx(Popover, { open: openDialog, trigger: ['click'], destroyTooltipOnHide: true, onOpenChange: (open) => (open ? onOpenDialog() : onCloseDialog()), content: (_jsx(TagsBulkEditDialog, { selectedProjects: selectedProjects, onRefetch: onRefetch, onClose: onCloseDialog, onComplete: () => {
                onComplete();
                onCloseDialog();
            } })), children: _jsx(IconButton, { className: toolbarStyles.toolbarButton, onClick: onOpenDialog, children: _jsx(TagsOutlined, {}) }) })));
};
export default TagsEditButton;
